import { create } from 'zustand';

type LivekitUiState = {
  chatOpen: boolean;
  setChatOpen: (open: boolean) => void;
  reset: () => void;
};

export const useLivekitUiStore = create<LivekitUiState>(set => ({
  chatOpen: false,
  setChatOpen: chatOpen => set({ chatOpen }),
  reset: () => set({ chatOpen: false }),
}));
